import { Component, ElementRef, ViewChild } from '@angular/core';
import { CustomToastService } from 'src/app/core/services/custom-toast.service';
import { MasterService } from 'src/app/core/services/master.service';
import {
  ChangePasswordModel,
  UserSelfModel,
} from 'src/app/features/company-portal/modules/user-management/models/user-management.models';
import { UsersManagementService } from 'src/app/features/company-portal/modules/user-management/services/user-management.service';
import { ConfirmEmail } from '../../models/shared.models';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css'],
  standalone: false,
})
export class UserProfileComponent {
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('closeCanvas') closeCanvas!: ElementRef;

  isProfileEdit: boolean = false;
  isBasicDetailsEdit: boolean = false;
  userInfo: any;
  companyId: number = 0;
  userObj: UserSelfModel = new UserSelfModel();
  userObjForName: UserSelfModel = new UserSelfModel();
  userObjForBasicDetails: UserSelfModel = new UserSelfModel();
  changePasswordObj: ChangePasswordModel = new ChangePasswordModel();
  userProfileUrl: string | null = null;
  previewUrl: string | ArrayBuffer | null = '';
  offCanvasVal: string = 'emailUpdate';
  uploadedFile: File | null = null;
  isNewProfile: boolean = false;
  tabIndx: number = 1;
  otpTimer: number = 0;
  otpInterval: any = 0;
  emailToUpdate: string = '';
  confirmEmail: ConfirmEmail = new ConfirmEmail();
  isEmailVarified: boolean = false;
  togglecpass: boolean = false;
  showOldPass: boolean = false;
  showNewPass: boolean = false;
  passWord: string = '';
  conFirmPassWord: string = '';
  isAbleToSet: boolean = false;
  isLoading: boolean = false;

  constructor(
    private masterService: MasterService,
    private toaster: CustomToastService,
    private userManagementService: UsersManagementService,
    private sharedService: SharedService,
    private toastr: CustomToastService,
  ) {}

  ngOnInit() {
    this.userInfo = this.masterService.getUserDetailFromStorage();
    this.companyId = this.userInfo.companyid;
    this.getUserDetailsById(true);
  }

  getUserDetailsById(isAfterUpdateCall: boolean = false) {
    let userId = this.userInfo.userid;
    this.userManagementService.getUserById(userId, isAfterUpdateCall).subscribe((res) => {
      let data = res as UserSelfModel;
      data.fullName = data.firstName + ' ' + data.lastName;
      this.userProfileUrl = data.profileFileUrl;
      this.userObj = JSON.parse(JSON.stringify(data));
      this.userObjForName = JSON.parse(JSON.stringify(data));
      this.userObjForBasicDetails = JSON.parse(JSON.stringify(data));
    });
  }

  cancelEdit(val: string) {
    switch (val) {
      case 'profile Edit':
        this.isProfileEdit = false;
        this.userObjForName.fullName = this.userObj.fullName;
        break;

      case 'basicDetails Edit':
        this.isBasicDetailsEdit = false;
        this.userObjForBasicDetails.phoneNumber = this.userObj.phoneNumber;
        break;
    }
  }

  manageEdits(val: string) {
    switch (val) {
      case 'profile Edit':
        this.isProfileEdit = !this.isProfileEdit;

        if (!this.isProfileEdit) {
          this.completeStatus(val);
        }
        break;

      case 'basicDetails Edit':
        this.isBasicDetailsEdit = !this.isBasicDetailsEdit;

        if (!this.isBasicDetailsEdit) {
          this.completeStatus(val);
        }
        break;
    }
  }

  completeStatus(val: string) {
    switch (val) {
      case 'profile Edit':
        this.isProfileEdit = false;
        break;
      case 'basicDetails Edit':
        this.isBasicDetailsEdit = false;
        break;
    }
  }
  validatePhone(value?: string): boolean {
    const phoneRegex = /^\+?[0-9\s\-()]{7,15}$/;
    if (!value) {
      this.toaster.error('Phone number is required.');
      return false;
    }
    if (!phoneRegex.test(value)) {
      this.toaster.error('Please enter a valid phone number (7–15 digits).');
      return false;
    }
    return true;
  }

  manageOffCanvasValues(val: string) {
    this.isNewProfile = false;
    this.tabIndx = 1;
    this.emailToUpdate = this.userInfo.email;
    this.isEmailVarified = false;
    this.changePasswordObj = new ChangePasswordModel();
    this.previewUrl = this.userProfileUrl;
    this.offCanvasVal = val;
  }

  selectProfile() {
    this.fileInput!.nativeElement.click();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      this.uploadedFile = input.files[0];

      const reader = new FileReader();
      reader.onload = () => {
        this.previewUrl = reader.result;
        this.isNewProfile = true;
      };
      reader.readAsDataURL(this.uploadedFile);
    }
  }

  removeImage() {
    this.uploadedFile = null;
    this.previewUrl = null;
    this.userProfileUrl = null;

    // Reset the input so the same file can be uploaded again
    const input = document.getElementById('fileInput') as HTMLInputElement;
    if (input) input.value = '';
    this.userManagementService.removeUserProfile(this.userInfo.userid).subscribe(
      (result) => {
        this.toaster.success('Profile Image removed successfully');
        const isAfterUpdateCall = true;
        this.getUserDetailsById(isAfterUpdateCall);
      },
      (error) => {
        this.sharedService.getErrorMessage(error);
      },
    );
  }

  chnageTabIndx(val: string) {
    this.tabIndx = val == 'next' ? this.tabIndx + 1 : this.tabIndx - 1;

    if (this.tabIndx == 2) {
      this.sendOtp();
    }

    if (this.tabIndx > 2) {
      let data = JSON.parse(JSON.stringify(this.userObjForBasicDetails));
      data.email = this.emailToUpdate;
      this.editUserDetails(data, 'emailUpdate');
    }
  }

  async sendOtp() {
    try {
      let isEmailSent = false;
      isEmailSent =
        (await this.sharedService.sendEmailOtp(this.emailToUpdate).toPromise()) || false;
      if (isEmailSent) {
        this.startOtpTimer();
      }
    } catch (err: any) {
      if (err?.error?.errors.length) {
        err.error.errors.forEach((er: any) => {
          this.toastr.error(er.message);
        });
      }
    }
  }

  onOtpChange(code: string) {
    const codeDigits = code.length;
    if (codeDigits > 5) {
      this.confirmEmail = {
        token: code,
        email: this.emailToUpdate,
      };
      this.confirmOtp();
    }
  }

  startOtpTimer() {
    let timeLeft = 60;
    this.otpTimer = timeLeft;
    this.otpInterval = setInterval(() => {
      this.otpTimer--;
      if (this.otpTimer <= 0) {
      }
    }, 1000);
  }

  async confirmOtp() {
    try {
      const isEmailConfirmed = await this.sharedService.confirmEmail(this.confirmEmail).toPromise();
      if (isEmailConfirmed) {
        this.toastr.success('Verification successful');
        this.isEmailVarified = true;
      }
    } catch (err: any) {
      if (err?.error?.errors.length) {
        err.error.errors.forEach((er: any) => {
          this.toastr.error(er.message);
          this.isEmailVarified = false;
        });
      }
    }
  }

  updateUserProfile() {
    if (this.uploadedFile) {
      let formData = new FormData();
      formData.append('file', this.uploadedFile);
      let compnayId = this.userInfo.companyid;
      let userId = this.userInfo.userid;
      this.userManagementService.addUserProfilePhoto(userId, formData, compnayId).subscribe(
        (res) => {
          this.toaster.success('User profile has been changed succesfully...');
          this.closeCanvas!.nativeElement.click();
          const isAfterUpdateCall = true;
          this.getUserDetailsById(isAfterUpdateCall);
        },
        (err: any) => {
          if (err.status === 400 && err.error.errors) {
            let validationMessages = err.error.errors
              .map((error: any) => `${error.field}: ${error.message}`)
              .join('\n');

            this.toaster.error(validationMessages);
          } else {
            this.toaster.error(err.error.detail || 'An unexpected error occurred.');
          }
        },
      );
    } else {
      console.error('No file selected.');
    }
  }

  editUserDetails(userData: UserSelfModel, val: string) {
    userData.firstName = userData.fullName.split(' ')[0];
    userData.lastName = userData.fullName.split(' ')[1];

    // ✅ Stop if phone validation fails
    if (!this.validatePhone(this.userObjForBasicDetails.phoneNumber ?? '')) {
      return;
    }

    this.userManagementService.updateUserSelfDetails(userData).subscribe(
      (result) => {
        this.manageEdits(val);
        if (val == 'profile Edit') {
          this.toaster.success('User name has been updated successfully!');
        } else if (val == 'emailUpdate') {
          this.toaster.success('User email has been updated successfully!');
        } else {
          this.toaster.success('User contact has been updated successfully!');
        }

        this.closeCanvas!.nativeElement.click();
        const isAfterUpdateCall = true;
        this.getUserDetailsById(isAfterUpdateCall);
      },
      (err: any) => {
        if (err.status === 400 && err.error.errors) {
          let validationMessages = err.error.errors
            .map((error: any) => `${error.field}: ${error.message}`)
            .join('\n');
          this.toaster.error(validationMessages);
        } else {
          this.toaster.error(err.error.detail || 'An unexpected error occurred.');
        }
      },
    );
  }

  toggleOldPass() {
    this.showOldPass = !this.showOldPass;
  }
  toggleNewPass() {
    this.showNewPass = !this.showNewPass;
  }

  toggleCPasswordVisibility() {
    this.togglecpass = !this.togglecpass;
  }

  getBtnStatus() {
    this.isAbleToSet =
      this.changePasswordObj.oldPassword &&
      this.changePasswordObj.conformPassVal &&
      this.changePasswordObj.newPassword
        ? true
        : false;
  }
  chnageUserPassword() {
    this.isLoading = true;
    this.changePasswordObj.id = this.userInfo.userid;
    this.userManagementService.changePassword(this.changePasswordObj).subscribe(
      (res) => {
        this.toaster.success('User password has been changed succesfully...');
        this.closeCanvas!.nativeElement.click();
        const isAfterUpdateCall = true;
        this.getUserDetailsById(isAfterUpdateCall);
        this.isLoading = false;
      },
      (err: any) => {
        if (err.status === 400 && err.error.errors) {
          let validationMessages = err.error.errors
            .map((error: any) => `${error.field}: ${error.message}`)
            .join('\n');

          this.toaster.error(validationMessages);
        } else {
          this.toaster.error(err.error.detail || 'The old password is incorrect.');
        }
        this.isLoading = false;
      },
    );
  }
}
